import { render, staticRenderFns } from "./Donators.vue?vue&type=template&id=0d120138"
import script from "./Donators.vue?vue&type=script&lang=js"
export * from "./Donators.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports